'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/react/react.js
// module id = 1
// module chunks = 0